import { render, staticRenderFns } from "./PatientMaxHr.vue?vue&type=template&id=34f38eaa&"
import script from "./PatientMaxHr.vue?vue&type=script&lang=js&"
export * from "./PatientMaxHr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports